import { DecoderHelpers } from '@headless-workspace/utils';
import { z } from 'zod';
import { ImageDTO } from '../../../../../client';

export type MarketingBannerDTO = z.infer<typeof MarketingBannerDTO>;
export const MarketingBannerDTO = z.object({
    type: DecoderHelpers.caseInsensitiveLiteral('marketing'),
    id: z.string(),
    title: z.string().optional(),
    description: z.string().optional(),
    legalMention: z.string().optional(),
    image: ImageDTO,
    cta: z.object({
        label: z.string(),
        link: z.string(),
    }),
});
